export const config = {
    apiBaseUrl: "https://api.sudarshanholiday.com",
}